// get activities
export const GET_ACTIVITIES_START = "GET_ACTIVITIES_START";
export const GET_ACTIVITIES_SUCCESS = "GET_ACTIVITIES_SUCCESS";
export const GET_ACTIVITIES_FAIL = "GET_ACTIVITIES_FAIL";
// add activity
export const ADD_ACTIVITY_START = "ADD_ACTIVITY_START";
export const ADD_ACTIVITY_SUCCESS = "ADD_ACTIVITY_SUCCESS";
export const ADD_ACTIVITY_FAIL = "ADD_ACTIVITY_FAIL";

// Add advertisment
export const ADVERTISMENT_REQUEST = "ADVERTISMENT_REQUEST";
export const ADVERTISMENT_ADD_SUCCESS = "ADVERTISMENT_ADD_SUCCESS";
export const ADVERTISMENT_FAIL = "ADVERTISMENT_FAIL";

// Delete activity(adv)
export const DELETE_ACTIVITY_START = "DELETE_ACTIVITY_START";
export const DELETE_ACTIVITY_SUCCESS = "DELETE_ACTIVITY_SUCCESS";
export const DELETE_ACTIVITY_FAIL = "DELETE_ACTIVITY_FAIL";

// Delete activity(adv)
export const EDIT_ADVERTISMENT_START = "EDIT_ADVERTISMENT_START";
export const EDIT_ADVERTISMENT_SUCCESS = "EDIT_ADVERTISMENT_SUCCESS";
export const EDIT_ADVERTISMENT_FAIL = "EDIT_ADVERTISMENT_FAIL";

export const SAVE_ADVERTISMENT_FILTER = "SAVE_ADVERTISMENT_FILTER";
export const SELECTED_CONTACTS_FOR_ADVERTISMENT = "SELECTED_CONTACTS_FOR_ADVERTISMENT";

export const SAVE_POLL_FILTER = "SAVE_POLL_FILTER";
export const PATCH_POLL_OPTION = "PATCH_POLL_OPTION";
